<!-- Contextual bar -->
@if (config$ | async; as config) {
    <div class="contextual-bar-wrap">
        <div class="contextual-bar">

            <!-- Back button -->
            <button class="circle-btn" (click)="goBack()" aria-label="Go back">
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-back-arrow-left'">
                </app-custom-icon>
            </button>

            <!-- Section switcher -->
            <button class="section-switcher" (click)="toggleSwitcher()" [attr.aria-label]="'Switch section, current: ' + config.currentLabel">
                <span class="section-label">{{ config.currentLabel }}</span>
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-chevron-up'">
                </app-custom-icon>
            </button>

            <!-- Add button (conditional) -->
            @if (config.showAdd) {
                <button
                    class="circle-btn circle-btn--blue"
                    (click)="triggerAdd(config)"
                    aria-label="Add">
                    <app-custom-icon
                        [iconPath]="'assets/icons/general-icons.svg'"
                        [imageName]="'icon-add-new'">
                    </app-custom-icon>
                </button>
            }
        </div>
        <app-rise-agent-mobile-fab *featureFlag="'riseAgent'"></app-rise-agent-mobile-fab>
    </div>

    <!-- Section switcher slide-up panel -->
    <div class="switcher-overlay" [class.open]="showSwitcher" (click)="closeSwitcher()"></div>
    <div class="switcher-panel" [class.open]="showSwitcher">
        <div class="panel-header">
            <span class="panel-title">{{ config.parentLabel }}</span>
            <button class="panel-close" (click)="closeSwitcher()" aria-label="Close">
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-close'">
                </app-custom-icon>
            </button>
        </div>
        <ul class="panel-options">
            @for (option of config.siblings; track option.label) {
                <li>
                    <button
                        [routerLink]="option.link"
                        [queryParams]="option.query"
                        [class.active]="option.label === config.currentLabel"
                        (click)="closeSwitcher()">
                        <div class="option-marker"></div>
                        <h6>{{ option.label }}</h6>
                    </button>
                </li>
            }
        </ul>
    </div>
}

